import React from 'react';
// import { Redirect } from "react-router-dom";
// import Cookies from 'js-cookie';
import Highlighter from 'react-highlight-words';
// import { Link } from "react-router-dom";
import {
	Card,
	Row,
	Col,
	Input,
	Button,
	Table,
	Modal,
	message,
	Tag,
	Select,
	Spin,
	Form,
	Upload,
	Typography,
	Tooltip,
	Pagination,
} from 'antd';
import {
	SearchOutlined,
	ExclamationCircleOutlined,
	RedoOutlined,
	SettingOutlined,
	SyncOutlined,
	ClockCircleOutlined,
	CheckCircleOutlined,
	CloseCircleOutlined,
	CloseOutlined,
	UploadOutlined,
	FileExcelOutlined,
	DownloadOutlined,
} from '@ant-design/icons';

// import axios from 'axios';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	ajaxHandler_upload,
	setConfig,
} from "../../store/actions";


import moment from "moment";

import Config from '../../Config';
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Import NJKB',
	apiUrl: {
		data: 'kendaraan/api/upload/njkb/',
		jenis_kendaraan: "master/api/jenis/kendaraan/"
	},

	breadCrumb: [
		<span><SettingOutlined /> Master</span>,
		'Import NJKB'
	]

}

const config = new Config();

class DataImportNjkb extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			loadingJenisKendaraan: false,
			listJenisKendaraan: [],

			document: null,
			modalImport: false,

			errMsg: '',
			errTitle: '',
			loadingData: false,
			loadingButton: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			searchColumn: '',
			dataSource: [],
			isMobile: window.innerWidth <= 768,
		}
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getData();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	setDocument = (e) => {
		this.setState({
			document: e.target.files[0]
		});
	}


	loadMasterList() {
		const rule = [
			{
				destination: {
					stateProgressName: "loadingJenisKendaraan",
					endPoint: configClass.apiUrl.jenis_kendaraan,
					stateDestination: "listJenisKendaraan",
				},
				nextDestination: null
			}
		];

		this.setState({
			errComponent: false,
		});

		rule.map((item, index) => {
			if (index == rule.length - 1) {
				this.getMasterList(item, true);
			} else {
				this.getMasterList(item);
			}
		});
	}

	async getMasterList(rule, isFinal = false) {
		var destination = rule.destination;
		var nextDestination = rule.nextDestination;
		this.setState({ [destination.stateProgressName]: true });
		this.props
			.ajaxViewHandler("get", destination.endPoint)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					if (data.count != undefined) {
						let newState = null;
						if (this.state[destination.stateDestination].length == 0) {
							newState = data;
						} else {
							if (destination.stateProgressName.includes("_searching")) {
								newState = data;
							} else {
								const oldState = this.state[destination.stateDestination];
								newState = {
									count: data.count,
									next: data.next,
									previous: data.previous,
									results: [...oldState.results, ...data.results],
								};
							}
						}
						this.setState({
							[destination.stateDestination]: newState,
						});
					} else if (data.results != undefined) {
						this.setState({
							[destination.stateDestination]: data.results,
						});
					} else {
						if (Array.isArray(data)) {
							this.setState({
								[destination.stateDestination]: data,
							});
						} else {
							this.setState({
								[destination.stateDestination]: [data],
							});
						}
					}
					if (isFinal) {
						if (this.props.match.params.id != undefined) {
							// this.preview(this.props.match.params.id);
						}
					}
				} else {
					this.setState({
						errComponent: true,
					});
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch((response) => {
				console.log('gagal_get_master', response);
				message.error({
					content: "gagal request data, coba lagi",
					duration: 2,
					key: "toast",
				});
				this.setState({
					errTitle: "gagal request data master",
					errMsg: response,
				});
				this.setState({ [destination.stateProgressName]: false });
			});
		//next function
		if (nextDestination != null) {
			const next = {
				destination: {
					stateProgressName: nextDestination.stateProgressName,
					endPoint: nextDestination.endPoint,
					stateDestination: nextDestination.stateDestination,
				},
				nextDestination: nextDestination.next,
			};
			this.getMasterList(next);
		}
	}

	generateSelect(stateName, url, key, value, keyDisplay = "") {
		return this.state["loading" + stateName] ? (
			<img src={process.env.PUBLIC_URL + "/loading_crop.gif"} alt="gbr" height="50" />
		) : (
			<Select
				showSearch
				placeholder={"Cari / Pilih " + stateName}
				optionFilterProp="children"
				onSearch={(val) => {
					let urls = url + "?search=" + val;
					if (stateName == "Upt") {
						urls = `${url}?kabupaten=${this.state.kabupaten_id}&search=${val}`;
					}
					const rule = {
						destination: {
							stateProgressName: "loading" + stateName + "_searching",
							endPoint: urls,
							stateDestination: "list" + stateName,
						},
						nextDestination: null,
					};
					this.getMasterList(rule);
				}}
				onPopupScroll={(e) => {
					e.persist();
					let target = e.target;
					if (target.scrollTop + target.offsetHeight == target.scrollHeight) {
						if (
							this.state["list" + stateName].next != undefined &&
							this.state["list" + stateName].next != null
						) {
							const rule = {
								destination: {
									stateProgressName: "loading" + stateName + "Paging",
									endPoint: this.state["list" + stateName].next,
									stateDestination: "list" + stateName,
								},
								nextDestination: null,
							};
							this.getMasterList(rule);
						}
					}
				}}
				allowClear
				style={{
					width: "100%",
				}}
				onChange={(val) => {
					if (stateName == "Kabupaten") {
						this.setState({
							kabupaten_id: val
						}, () => {
							const rule = {
								destination: {
									stateProgressName: "loadingUpt",
									endPoint: configClass.apiUrl.upt + "?kabupaten=" + val,
									stateDestination: "listUpt",
								},
								nextDestination: null,
							};
							this.getMasterList(rule);
						});
					}
				}}
				size={"small"}
			>
				{this.state["loading" + stateName + "_searching"] == true && (
					<Select.Option value="">
						<Spin size="small" />
					</Select.Option>
				)}
				{this.state["list" + stateName].count != undefined
					? this.state["list" + stateName].results.map((item) => (
						<Select.Option value={item[key]}>
							{keyDisplay == ""
								? item[key] + " - " + item[value]
								: item[keyDisplay] + " - " + item[value]}
						</Select.Option>
					))
					: this.state["list" + stateName].map((item) => (
						<Select.Option value={item[key]}>
							{keyDisplay == ""
								? item[key] + " - " + item[value]
								: item[keyDisplay] + " - " + item[value]}
						</Select.Option>
					))}
				{this.state["list" + stateName] != undefined &&
					this.state["list" + stateName].next != undefined && (
						<Select.Option value="">
							<Spin size="small" />
						</Select.Option>
					)}
			</Select>
		);
	}

	showDeleteConfirm(id) {
		Modal.confirm({
			title: 'Konfirmasi Hapus?',
			icon: <ExclamationCircleOutlined />,
			content: 'yakin menghapus data?',
			okText: 'Ya',
			okType: 'danger',
			cancelText: 'Tidak',
			onOk: () => this.prosesHapus(id),
			onCancel() {
				//console.log('Cancel');
			},
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				this.setState({
					loadingButton: false
				});
				if (this.props.isSuccess) {
					message.success({ content: 'berhasil menghapus data', duration: 2, key: 'toast' });
					this.getData();
				} else {
					const errTitle = 'gagal menghapus data'
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({
						errTitle: errTitle,
						errMsg: this.props.responseMsg
					});
				}
			}).catch((response) => {
				console.log('gagal_delete', response);
				this.setState({
					loadingButton: false
				});
				message.error({ content: 'kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	getColumnSearchProps = dataIndex => ({
		filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={node => {
						this.searchInput = node;
					}}
					placeholder={`Search ${dataIndex}`}
					value={selectedKeys[0]}
					onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
					style={{ width: 188, marginBottom: 8, display: 'block' }}
				/>
				<Button
					type="primary"
					onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
					icon={<SearchOutlined />}
					size="small"
					style={{ width: 90, marginRight: 8 }}
				>
					Search
				</Button>
				<Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
					Reset
				</Button>
			</div>
		),
		filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
		onFilter: (value, record) =>
			record[dataIndex]
				.toString()
				.toLowerCase()
				.includes(value.toLowerCase()),
		onFilterDropdownVisibleChange: visible => {
			if (visible) {
				setTimeout(() => this.searchInput.select());
			}
		},
		render: text =>
			this.state.searchedColumn == dataIndex ? (
				<Highlighter
					highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
					searchWords={[this.state.searchText]}
					autoEscape
					textToHighlight={text.toString()}
				/>
			) : (
				text
			),
	});

	handleSearch = (selectedKeys, confirm, dataIndex) => {
		confirm();
		this.setState({
			searchText: selectedKeys[0],
			searchedColumn: dataIndex,
		});
	};

	handleReset = clearFilters => {
		clearFilters();
		this.setState({ searchText: '' });
	};

	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });

		this.props.ajaxViewHandler('get', configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					const errTitle = 'error get data';
					this.setState({
						errTitle: errTitle,
						errMsg: this.props.responseMsg
					});
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			}).catch((response) => {
				console.log('gagal_get_preview', response);
				message.error({ content: 'gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	};

	handleTableChange = (pagination) => {
		this.setState({
			pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current },
		});
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize);
	};

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize);
	};

	closeModalImport = () => {
		this.setState({ modalImport: false, document: null });
	};

	handleSubmit = (values) => {
		// var datas = new FormData();
		const formData = new FormData();

		// for (var key in values) {
		// 	if (values[key] == undefined) {
		// 		datas.append(key, "");
		// 	} else {
		// 		datas.append(key, (values[key]).toString());
		// 	}
		// }
		// for (var t in e) void 0 == e[t] ? a.append(t, "") : a.append(t, e[t].toString());
		// for (var key in values) void 0 == values[key] ? datas.append(key, "") : datas.append(key, values[key].toString());
		if (this.state.document != null) {
			formData.append("lampiran", this.state.document, this.state.document.name);
			formData.append("jenis_kendaraan", values.jenis_kendaraan);
			// console.log('file', this.state.document);
			// console.log('jenis', values.jenis_kendaraan);
		} else {
			// formData.append("lampiran", "");
			console.log('kosong')
		}
		for (let pair of formData.entries()) {
			console.log(pair[0], pair[1]);
		}
		// console.log('data', formData);
		//formData.append('created_at', '01-01-2020');
		this.postData(formData);
	}

	async postData(datas) {
		message.loading({ content: 'Memproses...', key: 'toast' });

		try {
			const response = await this.props.ajaxHandler_upload(
				"post",
				configClass.apiUrl.data,
				datas,
				true, // isFormData
				false, // useAuth
				'',    // customHeader
				true   // autoMultipart
			);

			this.setState({ loadingButton: false });

			if (this.props.isSuccess) {
				message.success({ content: 'berhasil menyimpan data', key: 'toast' });
				this.closeModalImport();
				this.getData();
			} else {
				const errTitle = 'gagal menyimpan data';
				message.error({ content: errTitle, key: 'toast' });
				this.setState({
					errTitle,
					errMsg: this.props.responseMsg
				});
			}
		} catch (error) {
			console.log('gagal_post', error);
			this.setState({ loadingButton: false });
			message.error({ content: 'kesalahan pengiriman data, coba lagi', key: 'toast' });
		}
	}

	_statusTag(value, statusNama) {
		if (value == "1") {
			return <Tag icon={<ClockCircleOutlined />} style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#fffbe6', borderColor: '#ffe58f', color: '#ad6800' }}>{statusNama}</Tag>;
		}
		if (value == "2") {
			return <Tag icon={<SyncOutlined spin />} style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#e6f0fb', borderColor: '#91b4e8', color: '#1e4d8a' }}>{statusNama}</Tag>;
		}
		if (value == "3") {
			return <Tag icon={<CheckCircleOutlined />} style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d' }}>{statusNama}</Tag>;
		}
		return <Text type="secondary">—</Text>;
	}

	_buildColumns() {
		return [
			{
				title: 'No',
				key: 'no',
				width: 56,
				align: 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return (
						<Text style={{ fontSize: 12, color: '#888' }}>
							{(pagination.current - 1) * pagination.pageSize + index + 1}
						</Text>
					);
				},
			},
			{
				title: 'Jenis Kendaraan',
				dataIndex: 'jenis_kendaraan_nama',
				key: 'jenis_kendaraan_nama',
				render: (value) => (
					<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
						<div style={{
							width: 34, height: 34, borderRadius: 8,
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
						}}>
							<FileExcelOutlined style={{ color: '#fff', fontSize: 15 }} />
						</div>
						<div style={{ fontWeight: 600, fontSize: 13, color: '#222' }}>{value || '—'}</div>
					</div>
				),
			},
			{
				title: 'Status',
				dataIndex: 'status',
				key: 'status',
				width: 150,
				align: 'center',
				render: (value, row) => this._statusTag(value, row.status_nama),
			},
			{
				title: 'Success',
				dataIndex: 'success',
				key: 'success',
				width: 100,
				align: 'center',
				render: (val) => (
					<Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', minWidth: 32 }}>
						{val ?? 0}
					</Tag>
				),
			},
			{
				title: 'Gagal',
				dataIndex: 'gagal',
				key: 'gagal',
				width: 100,
				align: 'center',
				render: (val) => (
					<Tag style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', minWidth: 32 }}>
						{val ?? 0}
					</Tag>
				),
			},
			{
				title: 'Lampiran',
				dataIndex: 'lampiran',
				key: 'lampiran',
				width: 110,
				align: 'center',
				render: (value) => value != null ? (
					<Tooltip title="Download lampiran">
						<a href={value} target="_blank" rel="noopener noreferrer">
							<Button size="small" shape="circle" type="primary" ghost icon={<DownloadOutlined />} />
						</a>
					</Tooltip>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Koreksi',
				dataIndex: 'koreksi',
				key: 'koreksi',
				width: 110,
				align: 'center',
				render: (value) => value != null ? (
					<Tooltip title="Download koreksi">
						<a href={value} target="_blank" rel="noopener noreferrer">
							<Button size="small" shape="circle" danger ghost icon={<DownloadOutlined />} />
						</a>
					</Tooltip>
				) : <Text type="secondary">—</Text>,
			},
			{
				title: 'Dibuat',
				dataIndex: 'created_at',
				key: 'created_at',
				width: 150,
				render: (value) => value ? moment(value).format("DD-MM-YYYY HH:mm:ss") : '—',
			},
		];
	}

	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 0 }}
			>
				<div style={{
					background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
					borderBottom: '1px solid #d0dff5',
					padding: '12px 16px',
					display: 'flex', alignItems: 'center', gap: 12,
				}}>
					<div style={{
						width: 44, height: 44, borderRadius: 12,
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
					}}>
						<FileExcelOutlined style={{ color: '#fff', fontSize: 20 }} />
					</div>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847', lineHeight: 1.3 }}>
							{row.jenis_kendaraan_nama || '—'}
						</div>
						<div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
							{row.created_at ? moment(row.created_at).format("DD-MM-YYYY HH:mm") : '—'}
						</div>
					</div>
					{this._statusTag(row.status, row.status_nama)}
				</div>
				<div style={{ padding: '10px 16px' }}>
					<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
						<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#f6ffed', borderColor: '#b7eb8f', color: '#389e0d', fontWeight: 600 }}>
							Success: {row.success ?? 0}
						</Tag>
						<Tag style={{ borderRadius: 20, fontSize: 11, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322', fontWeight: 600 }}>
							Gagal: {row.gagal ?? 0}
						</Tag>
					</div>
					<div style={{ display: 'flex', gap: 6 }}>
						{row.lampiran != null && (
							<a href={row.lampiran} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>
								<Button block size="small" icon={<DownloadOutlined />}>Lampiran</Button>
							</a>
						)}
						{row.koreksi != null && (
							<a href={row.koreksi} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>
								<Button block size="small" danger icon={<DownloadOutlined />}>Koreksi</Button>
							</a>
						)}
					</div>
				</div>
			</Card>
		);
	}

	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText, modalImport } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + " | " + config.get_site_info().name}</title>
					<style>{`
						.data-importnjkb-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700;
							font-size: 13px;
							color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.data-importnjkb-wrap .ant-table-tbody > tr > td {
							padding: 12px 16px;
							vertical-align: middle;
						}
						.data-importnjkb-wrap .ant-table-tbody > tr:hover > td {
							background: #e8f0fb !important;
						}
						.data-importnjkb-wrap .ant-table-tbody > tr:nth-child(even) > td {
							background: #fafafa;
						}
						.data-importnjkb-wrap .ant-table-tbody > tr:nth-child(even):hover > td {
							background: #e8f0fb !important;
						}
						.form-importnjkb-modal .ant-modal-content {
							border-radius: 16px;
							overflow: hidden;
							padding: 0;
							box-shadow: 0 12px 40px rgba(15,40,71,0.25);
						}
						.form-importnjkb-modal .ant-modal-body { padding: 0; }
						.form-importnjkb-modal .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-importnjkb-modal .ant-select-selector {
							border-radius: 8px !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Card
					className="data-importnjkb-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<FileExcelOutlined style={{ marginRight: 8 }} />
								{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Total {pagination.total || 0} data import
								{loadingData && ' · Memuat...'}
							</div>
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh data">
								<Button
									onClick={() => {
										this.setState(
											prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
											() => this.getData(this.state.pagination.pageSize, 0, '')
										);
									}}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Button
								type="primary"
								icon={<UploadOutlined />}
								onClick={() => {
									this.setState({ modalImport: true }, () => {
										this.loadMasterList();
									});
								}}
								style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
							>
								{isMobile ? 'Import' : 'Import Data'}
							</Button>
						</div>
					</div>

					{/* Search bar */}
					<div style={{
						padding: '12px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari jenis kendaraan..."
							allowClear
							size="middle"
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: 340 }}
							value={searchText}
							onChange={this.handleSearchChange}
							onClear={() => {
								this.setState(
									prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
									() => this.getData(this.state.pagination.pageSize, 0, '')
								);
							}}
						/>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
								) : dataSource.length === 0 ? (
									<div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Tidak ada data</div>
								) : (
									dataSource.map(row => this.renderMobileCard(row))
								)}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current}
											pageSize={pagination.pageSize}
											total={pagination.total}
											onChange={this.handleMobilePageChange}
											showSizeChanger={false}
											simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: pagination.current,
									pageSize: pagination.pageSize,
									total: pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>

				{/* Modal Import */}
				<Modal
					visible={modalImport}
					onCancel={this.closeModalImport}
					footer={null}
					closable={false}
					destroyOnClose
					width={isMobile ? '94%' : 480}
					className="form-importnjkb-modal"
				>
					<Form
						layout="vertical"
						name="fdata"
						onFinish={this.handleSubmit}
						ref={this.formRef}
					>
						{/* Header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 48, height: 48, borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
							}}>
								<FileExcelOutlined style={{ color: '#fff', fontSize: 22 }} />
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 17, lineHeight: 1.3 }}>
									Import Data NJKB
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
									Upload file Excel (.xlsx) data NJKB
								</div>
							</div>
							<Button shape="circle" icon={<CloseOutlined />} onClick={this.closeModalImport}
								style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', flexShrink: 0 }} />
						</div>

						{/* Body */}
						<div style={{ padding: '24px 24px 8px' }}>
							<Form.Item
								label="Lampiran"
								name="lampiran"
								rules={[{ required: true, message: 'harus diisi' }]}
							>
								<Upload
									beforeUpload={(file) => {
										this.setState({ document: file });
										return false; // prevent auto upload
									}}
									accept=".xlsx"
									maxCount={1}
								>
									<Button icon={<UploadOutlined />} style={{ borderRadius: 8 }}>Pilih File</Button>
								</Upload>
							</Form.Item>

							<Form.Item
								label="Jenis Kendaraan"
								name="jenis_kendaraan"
								rules={[{ required: true, message: 'harus diisi' }]}
							>
								{this.generateSelect(
									"JenisKendaraan",
									configClass.apiUrl.jenis_kendaraan,
									"id",
									"nama",
									"kode"
								)}
							</Form.Item>
						</div>

						{/* Footer */}
						<div style={{
							padding: '16px 24px', marginTop: 4, display: 'flex', alignItems: 'center',
							justifyContent: 'flex-end', borderTop: '1px solid #f0f0f0', background: '#fafafa', gap: 10,
						}}>
							<Button icon={<CloseCircleOutlined />} onClick={this.closeModalImport} disabled={this.state.loadingButton} style={{ borderRadius: 10 }}>
								Batal
							</Button>
							<Button
								type="primary"
								htmlType="submit"
								icon={<CheckCircleOutlined />}
								loading={this.state.loadingButton}
								style={{ borderRadius: 10, background: 'linear-gradient(135deg, #0f2847, #1e4d8a)', border: 'none', fontWeight: 600 }}
							>
								Proses
							</Button>
						</div>
					</Form>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers
}

export default connect(
	mapStateToProps,
	{
		initHandler,
		setConfig,
		ajaxViewHandler,
		ajaxHandler,
		ajaxHandler_upload
	}
)(DataImportNjkb);